import { useProjectAttachmentsModel } from "widgets/project-attachments/hooks/useProjectAttachmentsModel"

import { ProjectAttachmentsOverlayConnectorProps } from "../ProjectAttachmentsOverlayConnector"

export function useProjectAttachmentsOverlayModel({
  payload: { projectID }
}: ProjectAttachmentsOverlayConnectorProps) {
  const attachmentsModel = useProjectAttachmentsModel({ projectID })

  return { attachmentsModel }
}
